"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CertificateDataChangeDetails {
    constructor(fieldMap, from, to) {
        this.fieldMap = fieldMap;
        this.from = from;
        this.to = to;
    }
    static fromObj(data) {
        var _a, _b, _c;
        return new CertificateDataChangeDetails((_a = data.fieldMap) !== null && _a !== void 0 ? _a : "", (_b = data.from) !== null && _b !== void 0 ? _b : "", (_c = data.to) !== null && _c !== void 0 ? _c : "");
    }
    static empty() {
        return new CertificateDataChangeDetails("", "", "");
    }
}
exports.default = CertificateDataChangeDetails;
//# sourceMappingURL=certificateChangeDetails.class.js.map